import type { DecisionAssessment } from '../decision/types';

export type OpportunityStage = 'PLAN' | 'PRESPEC' | 'BID';
export type OpportunityWorkType = 'SERVICE' | 'CONSTRUCTION';
export type OpportunityDataMode = 'LIVE' | 'DEMO' | 'CONFIGURATION_REQUIRED' | 'ERROR';
export type UpstreamCacheStatus = 'HIT' | 'MISS' | 'STALE' | 'BYPASS';

export type UpstreamCacheMeta = Readonly<{
  status: UpstreamCacheStatus;
  ttlSeconds: number;
  staleTtlSeconds: number;
  upstreamFetchedAt?: string;
}>;

export type Opportunity = Readonly<{
  id: string;
  stage: OpportunityStage;
  workType: OpportunityWorkType;
  title: string;
  agency: string;
  demandAgency?: string;
  region?: string;
  budget?: number;
  basePrice?: number;
  publishedAt?: string;
  closesAt?: string;
  qualificationSummary?: string;
  industryCodes?: readonly string[];
  historicalAwardRate?: number;
  historicalContractCount?: number;
  source: 'G2B';
  sourceUrl?: string;
  decision?: DecisionAssessment;
}>;

export type OpportunityFilters = Readonly<{
  keyword: string;
  region: string;
  workType: 'ALL' | OpportunityWorkType;
  stage: 'ALL' | OpportunityStage;
  minBudget: number | null;
  closingWithinDays: number | null;
  sort: 'NEWEST' | 'CLOSING_SOON' | 'BUDGET_DESC';
}>;

export type OpportunityApiResponse = Readonly<{
  mode: OpportunityDataMode;
  source: 'G2B';
  fetchedAt: string;
  opportunities: readonly Opportunity[];
  cache?: UpstreamCacheMeta;
  message?: string;
}>;

export const defaultOpportunityFilters: OpportunityFilters = {
  keyword: '',
  region: '',
  workType: 'ALL',
  stage: 'ALL',
  minBudget: null,
  closingWithinDays: 30,
  sort: 'NEWEST',
};
